import immutableStore from 'alt-utils/lib/ImmutableUtil';
import immutable from 'immutable';
import alt from 'components/Dispatcher';
import CrmSyncActions from 'actions/crm/CrmSyncActions';
import CrmSyncAccountsAndOpportunitiesPrefixSearchSource from 'sources/crm/CrmSyncAccountsAndOpportunitiesPrefixSearchSource';
import makePromiseCancelable from './makePromiseCancelable';

/**
 * Store the state of <CallSyncCRMRelatedToSearchInputBox/>
 */
@immutableStore
class CrmSyncAccountsAndOpportunitiesPrefixSearchStore {
  constructor() {
    this.state = immutable.Map({
      // options store the list of possible accounts/opportunities for the current search term
      options: immutable.List(),
      // total stores the number of total accounts/opportunities for the current search term since we show only a part
      // of the total instead of all of them
      total: 0,
      // numReturned stores the number of accounts/opportunities returned for the current search term. This value is
      // used in combination with `total` to show how many accounts/opportunities remain to be returned and we can ask
      // the user to type more in order to narrow down the search results
      numReturned: 0,
      // loading is a boolean that indicates whether there is request running or not. This value is used for queueing
      // search requests
      loading: false,
      // searchPrefixPromise stores the current prefix search request as a promise
      searchPrefixPromise: null,
      searchPrefixPromiseIsCanceled: false,
    });
    this.bindActions(CrmSyncActions);
    this.registerAsync(CrmSyncAccountsAndOpportunitiesPrefixSearchSource);
  }

  /** Reset this.state.get('options') back to immutable.List() */
  onClearAccountsAndOpportunitiesOptions() {
    const state = this.state.set('options', immutable.List());
    this.setState(state);
  }

  onCancelPrefixSearchAccountsAndOpportunities() {
    let state = this.state.set('loading', false);
    const promise = this.state.get('searchPrefixPromise');
    if (promise) {
      promise.cancel();
      state = state.set('searchPrefixPromiseIsCanceled', true);
    }
    this.setState(state);
  }

  /**
   * Trigger a request to the backend to search for accounts/opportunities with the given term as their prefix
   * @param {string} term Current search term as the prefix
   */
  onPrefixSearchAccountsAndOpportunities(term) {
    setImmediate(() => {
      const searchPrefixReq = makePromiseCancelable(this.getInstance().searchPrefix(term));
      searchPrefixReq.promise
        .then(() => console.log('Resolved onPrefixSearchAccountsAndOpportunities'))
        .catch(({isCanceled, ...error}) => {
          console.log('onPrefixSearchAccountsAndOpportunities isCanceled', isCanceled);
        });
      const state = this.state.set('searchPrefixPromise', searchPrefixReq);
      this.setState(state);
    });
  }

  /**
   * Populate this.state.get('options') with server-side response that includes the accounts/opportunities for a given
   * search prefix
   * @param {object} resp Server-side response that includes accounts/opportunities related data
   */
  onPrefixSearchAccountsAndOpportunitiesSuccess(resp) {
    let state = this.state.set('loading', false);
    if (!(state.get('searchPrefixPromise') && state.get('searchPrefixPromiseIsCanceled'))) {
      const data = resp.data;
      state = state.set('options', immutable.List(data.accounts_and_opportunities));
      state = state.set('numReturned', data.num_returned);
      state = state.set('total', data.total);
    }
    state = state.set('searchPrefixPromise', null);
    state = state.set('searchPrefixPromiseIsCanceled', false);
    this.setState(state);
  }

  /** Update this.state.get('loading') */
  onPrefixSearchAccountsAndOpportunitiesLoading() {
    const state = this.state.set('loading', true);
    this.setState(state);
  }

  /** Update this.state.get('loading')
   * @param resp {Object} Server-side response that includes an error response
   */
  onPrefixSearchAccountsAndOpportunitiesError(resp) {
    let state = this.state.set('loading', false);
    state = state.set('searchPrefixPromise', null);
    state = state.set('searchPrefixPromiseIsCanceled', false);
    this.setState(state);
  }
}

export default alt.createStore(
  CrmSyncAccountsAndOpportunitiesPrefixSearchStore,
  'CrmSyncAccountsAndOpportunitiesPrefixSearchStore'
);
